import { Directive, HostListener, ElementRef, Renderer2, Input, Optional, Host } from '@angular/core';
import { AppConstants } from 'app/app.constants';
import { VirtualKeyboardComponent } from '@otas/utils/custom-components/virtual-keyboard/virtual-keyboard.component';

@Directive({
  selector: '[appFocusNext],appFocusNext',
  standalone: false
})
export class FocusNextDirective {
  @Input('appFocusNext') text: string;
  toSearch = AppConstants.toSearch;

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
    @Optional() @Host() private virtualKeyBoard: VirtualKeyboardComponent
  ) {}

  @HostListener('keydown', ['$event'])
  keyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();

      let nextField: any;
      let parent: any;
      let element: any;

      if (this.text === 'multi') {
        nextField = this.renderer.parentNode(this.renderer.parentNode(this.el.nativeElement));
        parent = this.getNthParent(nextField, 4);
      } else if (this.text === 'span') {
        nextField = this.getNthParent(this.el.nativeElement, 4);
        parent = this.getNthParent(nextField, 4);
        element = this.getNthParent(this.el.nativeElement, 2);
      } else {
        nextField = this.renderer.nextSibling(
          this.getNthParent(this.el.nativeElement, 3)
        );

        if (nextField) {
          parent = this.getNthParent(nextField, 4);
        } else {
          nextField = this.getNthParent(this.el.nativeElement, 5);
          parent = this.getNthParent(nextField, 4);
        }
      }

      if (parent) {
        const fields = Array.from(parent.querySelectorAll(this.toSearch)) as HTMLElement[];
        const current = element ? element : event.target;
        const index = fields.indexOf(current as HTMLElement);

        if (index === -1) {
          fields[0]?.focus();
        } else if ((index + 1) < fields.length) {
          setTimeout(() => {
            fields[index + 1].focus();
            if (this.virtualKeyBoard?.keyBoardPanel) {
              this.virtualKeyBoard.keyBoardPanel.hide();
            }
          }, 20);
        } else if (index === fields.length - 1) {
          fields[0]?.focus();
        }
      }
    }
  }

  selectClick(parent: any, targetEl: ElementRef) {
    setTimeout(() => {
      const fields = Array.from(parent.querySelectorAll(this.toSearch)) as HTMLElement[];
      const index = fields.indexOf(targetEl.nativeElement || targetEl);

      if (index === -1) {
        fields[0]?.focus();
      } else if ((index + 1) < fields.length) {
        setTimeout(() => {
          fields[index + 1].focus();
        }, 200);
      } else if ((index + 1) === fields.length - 1 || index === fields.length - 1) {
        fields[0]?.focus();
      }
    }, 100);
  }

  private getNthParent(element: any, level: number): any {
    let parent = element;
    for (let i = 0; i < level; i++) {
      if (!parent) return null;
      parent = this.renderer.parentNode(parent);
    }
    return parent;
  }
}
